import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Global } from '@emotion/react';
import ObserverPageLayout from 'components/observer-layout/ObserverPageLayout';
import { PrerenderGlobalStyles } from 'helpers/rendering/prerenderGlobalStyles';
import { reset } from 'stylesheets/emotion/reset';
export function ObserverHoldingContent() {
    return (_jsxs(_Fragment, { children: [_jsx(Global, { styles: reset }), _jsx(PrerenderGlobalStyles, {}), _jsx(ObserverPageLayout, { borderBox: false, children: null })] }));
}
